import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostListener, inject } from '@angular/core';
import { PopupWrapperComponent } from '../popup-wrapper/popup-wrapper.component';
import { PopupManagerService } from 'src/app/services/popup/popup-manager.service';

@Component({
  selector: 'app-popup-host',
  imports: [CommonModule, PopupWrapperComponent],
  template: `
  @for( entry of popupManager.popups(); track entry.id){
    <app-popup-wrapper [entry]="entry"/>
  }`,
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class PopupHostComponent {
  popupManager = inject(PopupManagerService);
  
  constructor() {}

  @HostListener('window:keydown',[`$event`])
  handleKeyboardNavigation(event: KeyboardEvent): void {
    if(event.ctrlKey && event.key.toLowerCase() === 'q') {
      event.preventDefault();

      const reverse = event.shiftKey;

      this.popupManager.switchPopup(reverse);
    }
  }
}
